module.exports = __webpack_public_path__ + "img/German.eea10e57.svg";